import { useEffect } from "react";

// Scroll to top whenever `dependency` changes (and on mount).
// Runs in an effect, not during render, so the Promise that Chrome 150+ returns
// from window.scrollTo is never passed to React as a child (avoids React error #31).
const useScrollToTop = (dependency) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependency]);
};

export default useScrollToTop;
